// extracted by mini-css-extract-plugin
export default {"skeletonHorizontalItem":"SkeletonHorizontalItem_skeletonHorizontalItem__5vVfP","squareImg":"SkeletonHorizontalItem_squareImg__nZJaa"};